import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  style: {"width":"100%","justify-content":"center","display":"flex"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeasePeriodsFilters = _resolveComponent("LeasePeriodsFilters")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_LeasePeriodListItem = _resolveComponent("LeasePeriodListItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'content-block': !_ctx.previewModeOnly })
  }, [
    (!_ctx.previewModeOnly)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "Lease Periods"))
      : _createCommentVNode("", true),
    (!_ctx.previewModeOnly)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_LeasePeriodsFilters, {
      class: "mb-4",
      "lease-period-filters": _ctx.filters,
      semesters: _ctx.semesters
    }, null, 8, ["lease-period-filters", "semesters"]),
    (_ctx.isLeasePeriodLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leasePeriodsFiltered, (leasePeriod) => {
      return (_openBlock(), _createBlock(_component_LeasePeriodListItem, {
        key: leasePeriod.id,
        class: "mb-4",
        "lease-period": leasePeriod,
        onApply: _ctx.checkAvailability
      }, null, 8, ["lease-period", "onApply"]))
    }), 128))
  ], 2))
}